import { put, takeLatest, all, call } from 'redux-saga/effects';

import axiosClient from '../configs/axios';
import {
    ADD_CUSTOMER_FAILURE, ADD_CUSTOMER_PROGRESS, ADD_CUSTOMER_SUCCESS, ADD_CYLINDER_FAILURE,
    ADD_CYLINDER_HOLDING_LIMIT_FAILURE, ADD_CYLINDER_HOLDING_LIMIT_PROGRESS, ADD_CYLINDER_HOLDING_LIMIT_SUCCESS,
    ADD_CYLINDER_PROGRESS, ADD_CYLINDER_SUCCESS, ADD_DELIVERY_CHALLAN_FAILURE, ADD_DELIVERY_CHALLAN_PROGRESS, ADD_DELIVERY_CHALLAN_SUCCESS, ADD_INDUSTRY_FAILURE, ADD_INDUSTRY_PROGRESS, ADD_INDUSTRY_SUCCESS,
    ADD_UNIT_FAILURE, ADD_UNIT_PROGRESS, ADD_UNIT_SUCCESS, ADD_RATE_FAILURE, ADD_RATE_PROGRESS,
    ADD_RATE_SUCCESS, ADD_RM_FAILURE, ADD_RM_PROGRESS, ADD_RM_SUCCESS, ADD_ACCOUNT_MANAGER_FAILURE, ADD_ACCOUNT_MANAGER_PROGRESS,
    ADD_ACCOUNT_MANAGER_SUCCESS, ADD_CUSTOMER_PO_FAILURE, ADD_CUSTOMER_PO_PROGRESS, ADD_CUSTOMER_PO_SUCCESS, ADD_UOM_CONVERSION_FAILURE, ADD_UOM_CONVERSION_PROGRESS, ADD_UOM_CONVERSION_SUCCESS,
    ADD_UOM_FAILURE, ADD_UOM_PROGRESS, ADD_UOM_SUCCESS, EDIT_DELETE_CUSTOMER_FAILURE, EDIT_DELETE_CUSTOMER_PROGRESS,
    EDIT_DELETE_CUSTOMER_SUCCESS, EDIT_DELETE_CYLINDER_FAILURE, EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE,
    EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS, EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS, EDIT_DELETE_CYLINDER_PROGRESS,
    EDIT_DELETE_CYLINDER_SUCCESS, EDIT_DELETE_DELIVERY_CHALLAN_FAILURE, EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS, EDIT_DELETE_INDUSTRY_FAILURE, EDIT_DELETE_INDUSTRY_PROGRESS, EDIT_DELETE_INDUSTRY_SUCCESS,
    EDIT_DELETE_UNIT_FAILURE, EDIT_DELETE_UNIT_PROGRESS, EDIT_DELETE_UNIT_SUCCESS, EDIT_DELETE_RATE_FAILURE,
    EDIT_DELETE_RATE_PROGRESS, EDIT_DELETE_RATE_SUCCESS, EDIT_DELETE_RM_FAILURE, EDIT_DELETE_RM_PROGRESS, EDIT_DELETE_RM_SUCCESS,
    EDIT_DELETE_ACCOUNT_MANAGER_FAILURE, EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS,
    EDIT_DELETE_CUSTOMER_PO_FAILURE,
    EDIT_DELETE_CUSTOMER_PO_PROGRESS,
    EDIT_DELETE_CUSTOMER_PO_SUCCESS,
    EDIT_DELETE_UOM_CONVERSION_FAILURE, EDIT_DELETE_UOM_CONVERSION_PROGRESS, EDIT_DELETE_UOM_CONVERSION_SUCCESS,
    EDIT_DELETE_UOM_FAILURE, EDIT_DELETE_UOM_PROGRESS, EDIT_DELETE_UOM_SUCCESS, GET_CUSTOMER_LIST_FAILURE, GET_CUSTOMER_LIST_PROGRESS,
    GET_CUSTOMER_LIST_SUCCESS, GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE, GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS,
    GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS, GET_CYLINDER_LIST_FAILURE, GET_CYLINDER_LIST_PROGRESS, GET_CYLINDER_LIST_SUCCESS,
    GET_DELIVERY_CHALLAN_LIST_FAILURE,
    GET_DELIVERY_CHALLAN_LIST_PROGRESS,
    GET_DELIVERY_CHALLAN_LIST_SUCCESS,
    GET_INDUSTRY_LIST_FAILURE, GET_INDUSTRY_LIST_PROGRESS, GET_INDUSTRY_LIST_SUCCESS, GET_UNIT_LIST_FAILURE,
    GET_UNIT_LIST_PROGRESS, GET_UNIT_LIST_SUCCESS, GET_RATE_LIST_FAILURE, GET_RATE_LIST_PROGRESS, GET_RATE_LIST_SUCCESS,
    GET_RM_LIST_FAILURE, GET_RM_LIST_PROGRESS, GET_RM_LIST_SUCCESS, GET_ACCOUNT_MANAGER_LIST_FAILURE, GET_ACCOUNT_MANAGER_LIST_PROGRESS,
    GET_ACCOUNT_MANAGER_LIST_SUCCESS, GET_CUSTOMER_PO_LIST_FAILURE, GET_CUSTOMER_PO_LIST_PROGRESS, GET_CUSTOMER_PO_LIST_SUCCESS, GET_UOM_CONVERSION_LIST_FAILURE, GET_UOM_CONVERSION_LIST_PROGRESS,
    GET_UOM_CONVERSION_LIST_SUCCESS, GET_UOM_LIST_FAILURE, GET_UOM_LIST_PROGRESS, GET_UOM_LIST_SUCCESS, LOGIN_FAILURE, LOGIN_PROGRESS,
    LOGIN_SUCCESS, LOGOUT_FAILURE, LOGOUT_PROGRESS, LOGOUT_SUCCESS,
    GET_SUPPLIER_LIST_SUCCESS, GET_SUPPLIER_LIST_FAILURE, GET_SUPPLIER_LIST_PROGRESS, ADD_SUPPLIER_SUCCESS, ADD_SUPPLIER_FAILURE, ADD_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_FAILURE, EDIT_DELETE_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_SUCCESS,
    GET_DRIVER_LIST_FAILURE, GET_DRIVER_LIST_SUCCESS, GET_DRIVER_LIST_PROGRESS, ADD_DRIVER_FAILURE, ADD_DRIVER_PROGRESS, ADD_DRIVER_SUCCESS, EDIT_DELETE_DRIVER_FAILURE, EDIT_DELETE_DRIVER_PROGRESS, EDIT_DELETE_DRIVER_SUCCESS,
    GET_PRODUCT_LIST_FAILURE, GET_PRODUCT_LIST_SUCCESS, GET_PRODUCT_LIST_PROGRESS, ADD_PRODUCT_FAILURE, ADD_PRODUCT_PROGRESS, ADD_PRODUCT_SUCCESS, EDIT_DELETE_PRODUCT_FAILURE, EDIT_DELETE_PRODUCT_PROGRESS, EDIT_DELETE_PRODUCT_SUCCESS,
    GET_SCHEDULE_ENTRY_LIST_SUCCESS, GET_SCHEDULE_ENTRY_LIST_FAILURE, GET_SCHEDULE_ENTRY_LIST_PROGRESS, ADD_SCHEDULE_ENTRY_SUCCESS, ADD_SCHEDULE_ENTRY_FAILURE, ADD_SCHEDULE_ENTRY_PROGRESS, EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS, EDIT_DELETE_SCHEDULE_ENTRY_FAILURE, EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS,
    GET_GRN_LIST_SUCCESS,
    GET_GRN_LIST_FAILURE,
    GET_GRN_LIST_PROGRESS,
    ADD_GRN_SUCCESS,
    ADD_GRN_FAILURE,
    ADD_GRN_PROGRESS,
    EDIT_DELETE_GRN_SUCCESS,
    EDIT_DELETE_GRN_FAILURE,
    EDIT_DELETE_GRN_PROGRESS,
    GET_PRODUCTION_PLANNING_LIST_PROGRESS, GET_PRODUCTION_PLANNING_LIST_SUCCESS, GET_PRODUCTION_PLANNING_LIST_FAILURE,
    ADD_PRODUCTION_PLANNING_PROGRESS, ADD_PRODUCTION_PLANNING_SUCCESS, ADD_PRODUCTION_PLANNING_FAILURE,
    EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS, EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS, EDIT_DELETE_PRODUCTION_PLANNING_FAILURE,
    GET_CYLINDER_INWARD_LIST_SUCCESS, GET_CYLINDER_INWARD_LIST_FAILURE, GET_CYLINDER_INWARD_LIST_PROGRESS,
    ADD_CYLINDER_INWARD_SUCCESS, ADD_CYLINDER_INWARD_FAILURE, ADD_CYLINDER_INWARD_PROGRESS,
    EDIT_DELETE_CYLINDER_INWARD_SUCCESS, EDIT_DELETE_CYLINDER_INWARD_FAILURE, EDIT_DELETE_CYLINDER_INWARD_PROGRESS,
    GET_BOM_LIST_SUCCESS, GET_BOM_LIST_FAILURE, GET_BOM_LIST_PROGRESS,
    ADD_BOM_SUCCESS, ADD_BOM_FAILURE, ADD_BOM_PROGRESS,
    EDIT_DELETE_BOM_SUCCESS, EDIT_DELETE_BOM_FAILURE, EDIT_DELETE_BOM_PROGRESS,
    ADD_IMPORT_CUSTOMER_SUCCESS, ADD_IMPORT_CUSTOMER_FAILURE, ADD_IMPORT_CUSTOMER_PROGRESS,
    ADD_IMPORT_SUPPLIER_PROGRESS,
    ADD_IMPORT_SUPPLIER_FAILURE,
    ADD_IMPORT_SUPPLIER_SUCCESS,
    GET_CUSTOMER_TYPE_LIST_SUCCESS, GET_CUSTOMER_TYPE_LIST_FAILURE, GET_CUSTOMER_TYPE_LIST_PROGRESS, ADD_CUSTOMER_TYPE_SUCCESS, ADD_CUSTOMER_TYPE_FAILURE, ADD_CUSTOMER_TYPE_PROGRESS, EDIT_DELETE_CUSTOMER_TYPE_SUCCESS, EDIT_DELETE_CUSTOMER_TYPE_FAILURE, EDIT_DELETE_CUSTOMER_TYPE_PROGRESS,
    GET_CYLINDER_STATUS_LIST_SUCCESS, GET_CYLINDER_STATUS_LIST_FAILURE, GET_CYLINDER_STATUS_LIST_PROGRESS, ADD_CYLINDER_STATUS_SUCCESS, ADD_CYLINDER_STATUS_FAILURE, ADD_CYLINDER_STATUS_PROGRESS, EDIT_DELETE_CYLINDER_STATUS_SUCCESS, EDIT_DELETE_CYLINDER_STATUS_FAILURE, EDIT_DELETE_CYLINDER_STATUS_PROGRESS,
    EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS, EDIT_DELETE_PRODUCTION_ENTRY_FAILURE, EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS, ADD_PRODUCTION_ENTRY_PROGRESS, ADD_PRODUCTION_ENTRY_FAILURE, ADD_PRODUCTION_ENTRY_SUCCESS, GET_PRODUCTION_ENTRY_LIST_PROGRESS, GET_PRODUCTION_ENTRY_LIST_FAILURE, GET_PRODUCTION_ENTRY_LIST_SUCCESS,
    GET_QUALITY_ENTRY_LIST_SUCCESS, GET_QUALITY_ENTRY_LIST_FAILURE, GET_QUALITY_ENTRY_LIST_PROGRESS, ADD_QUALITY_ENTRY_SUCCESS, ADD_QUALITY_ENTRY_FAILURE, ADD_QUALITY_ENTRY_PROGRESS, EDIT_DELETE_QUALITY_ENTRY_SUCCESS, EDIT_DELETE_QUALITY_ENTRY_FAILURE, EDIT_DELETE_QUALITY_ENTRY_PROGRESS,
    ADD_DELIVERY_ORDER_PROGRESS,
    GET_DELIVERY_ORDER_LIST_SUCCESS,
    GET_DELIVERY_ORDER_LIST_FAILURE,
    GET_DELIVERY_ORDER_LIST_PROGRESS,
    ADD_DELIVERY_ORDER_SUCCESS,
    ADD_DELIVERY_ORDER_FAILURE,
    EDIT_DELETE_DELIVERY_ORDER_SUCCESS,
    EDIT_DELETE_DELIVERY_ORDER_FAILURE,
    EDIT_DELETE_DELIVERY_ORDER_PROGRESS,
    EDIT_DELETE_LOCATION_PROGRESS,
    EDIT_DELETE_LOCATION_FAILURE,
    EDIT_DELETE_LOCATION_SUCCESS,
    ADD_LOCATION_PROGRESS,
    ADD_LOCATION_FAILURE,
    ADD_LOCATION_SUCCESS,
    GET_LOCATION_LIST_PROGRESS,
    GET_LOCATION_LIST_FAILURE,
    GET_LOCATION_LIST_SUCCESS,
    GET_CPD_LIST_SUCCESS,
    GET_CPD_LIST_FAILURE,
    GET_CPD_LIST_PROGRESS,
    ADD_CPD_SUCCESS,
    ADD_CPD_FAILURE,
    ADD_CPD_PROGRESS,
    EDIT_DELETE_CPD_SUCCESS,
    EDIT_DELETE_CPD_FAILURE,
    EDIT_DELETE_CPD_PROGRESS,
    EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS,
    EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE,
    EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS,
    ADD_CUSTOMER_CATEGORY_PROGRESS,
    ADD_CUSTOMER_CATEGORY_FAILURE,
    ADD_CUSTOMER_CATEGORY_SUCCESS,
    GET_CUSTOMER_CATEGORY_LIST_PROGRESS,
    GET_CUSTOMER_CATEGORY_LIST_FAILURE,
    GET_CUSTOMER_CATEGORY_LIST_SUCCESS,
    GET_ECI_LIST_SUCCESS,
    GET_ECI_LIST_FAILURE,
    GET_ECI_LIST_PROGRESS,
    ADD_ECI_SUCCESS,
    ADD_ECI_FAILURE,
    ADD_ECI_PROGRESS,
    EDIT_DELETE_ECI_SUCCESS,
    EDIT_DELETE_ECI_FAILURE,
    EDIT_DELETE_ECI_PROGRESS,
    EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS,
    EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE,
    EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS,
    ADD_INTERNAL_MOVEMENT_PROGRESS,
    ADD_INTERNAL_MOVEMENT_FAILURE,
    ADD_INTERNAL_MOVEMENT_SUCCESS,
    GET_INTERNAL_MOVEMENT_LIST_PROGRESS,
    GET_INTERNAL_MOVEMENT_LIST_FAILURE,
    GET_INTERNAL_MOVEMENT_LIST_SUCCESS,
    EDIT_DELETE_VEHICLE_PROGRESS,
    EDIT_DELETE_VEHICLE_FAILURE,
    EDIT_DELETE_VEHICLE_SUCCESS,
    ADD_VEHICLE_PROGRESS,
    ADD_VEHICLE_FAILURE,
    ADD_VEHICLE_SUCCESS,
    GET_VEHICLE_LIST_PROGRESS,
    GET_VEHICLE_LIST_FAILURE,
    GET_VEHICLE_LIST_SUCCESS,
    EDIT_DELETE_ROUTE_PROGRESS,
    EDIT_DELETE_ROUTE_FAILURE,
    EDIT_DELETE_ROUTE_SUCCESS,
    ADD_ROUTE_PROGRESS,
    ADD_ROUTE_FAILURE,
    ADD_ROUTE_SUCCESS,
    GET_ROUTE_LIST_PROGRESS,
    GET_ROUTE_LIST_FAILURE,
    GET_ROUTE_LIST_SUCCESS,
    EDIT_DELETE_USER_PROGRESS,
    EDIT_DELETE_USER_FAILURE,
    EDIT_DELETE_USER_SUCCESS,
    ADD_USER_PROGRESS,
    ADD_USER_FAILURE,
    ADD_USER_SUCCESS,
    GET_USER_LIST_PROGRESS,
    GET_USER_LIST_FAILURE,
    GET_USER_LIST_SUCCESS,
    GET_DEPOT_LIST_SUCCESS,
    GET_DEPOT_LIST_FAILURE,
    GET_DEPOT_LIST_PROGRESS,
    ADD_DEPOT_SUCCESS,
    ADD_DEPOT_FAILURE,
    ADD_DEPOT_PROGRESS,
    EDIT_DELETE_DEPOT_SUCCESS,
    EDIT_DELETE_DEPOT_FAILURE,
    EDIT_DELETE_DEPOT_PROGRESS,
    ADD_CYLINDER_CSV_FAILURE,
    ADD_CYLINDER_CSV_SUCCESS,
    ADD_CYLINDER_CSV_PROGRESS,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS,
    ADD_CYLINDER_TAG_MAPPING_PROGRESS,
    ADD_CYLINDER_TAG_MAPPING_FAILURE,
    ADD_CYLINDER_TAG_MAPPING_SUCCESS,
    GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS,
    GET_CYLINDER_TAG_MAPPING_LIST_FAILURE,
    GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE,
    ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS,
    GET_PICKUP_LIST_SUCCESS,
    GET_PICKUP_LIST_FAILURE,
    GET_PICKUP_LIST_PROGRESS,
    ADD_PICKUP_SUCCESS,
    ADD_PICKUP_FAILURE,
    ADD_PICKUP_PROGRESS,
    EDIT_DELETE_PICKUP_SUCCESS,
    EDIT_DELETE_PICKUP_FAILURE,
    EDIT_DELETE_PICKUP_PROGRESS,


} from '../types/actionTypes';


// function* loginSaga(action) {
//     try {
//         const response = yield axiosClient.post('/login/login', action.payload);
//         sessionStorage.setItem('loginUser', JSON.stringify(response.data));
//         yield put({ type: LOGIN_SUCCESS, loginUser: response.data });
//     } catch (error) {
//         yield put({ type: LOGIN_FAILURE, payload: error.message });
//     }
// }

// function* watchLogin() {
//     yield takeLatest(LOGIN_PROGRESS, loginSaga);
// }

// function* logoutSaga(action) {
//     try {
//         const logoutSession = sessionStorage.removeItem('loginUser');
//         yield put({ type: LOGOUT_SUCCESS, loginUser: logoutSession });
//     } catch (error) {
//         yield put({ type: LOGOUT_FAILURE, payload: error.message });
//     }
// }

// function* watchLogout() {
//     yield takeLatest(LOGOUT_PROGRESS, logoutSaga);
// }

function* loginSaga(action) {
    try {
        // const loginUser = JSON.parse(sessionStorage.getItem('loginUser')); // Retrieve and parse the loginUser
        // const token = loginUser?.authToken; // Access the authToken

        // const response = yield call(axiosClient.post, '/login/login', action.payload, {
        //     headers: { authToken: `Bearer ${token}` } // Send the token in the headers
        // });
        
        const response = yield axiosClient.post('/login/login', action.payload);
        const loginUser = response.data.result;
        sessionStorage.setItem('loginUser', JSON.stringify(response.data));
        sessionStorage.setItem('authtoken', loginUser?.authToken);
        yield put({ type: LOGIN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: LOGIN_FAILURE, payload: error.message });
    }
}

const token =sessionStorage.getItem('authtoken');

function* watchLogin() {
    yield takeLatest(LOGIN_PROGRESS, loginSaga);
}

function* logoutSaga(action) {
    try {
        sessionStorage.removeItem('loginUser');
        sessionStorage.removeItem('authToken');
        yield put({ type: LOGOUT_SUCCESS });
    } catch (error) {
        yield put({ type: LOGOUT_FAILURE, payload: error.message });
    }
}

function* watchLogout() {
    yield takeLatest(LOGOUT_PROGRESS, logoutSaga);
}



// ============================= Customer Master ==============================

function* getCustomerListSaga(action) {
    try {
        const response = yield axiosClient.get(`customers/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CUSTOMER_LIST_SUCCESS, customer: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_LIST_FAILURE });
    }
}

function* watchGetCustomerList() {
    yield takeLatest(GET_CUSTOMER_LIST_PROGRESS, getCustomerListSaga);
}

function* addCustomerSaga(action) {
    try {
        const response = yield axiosClient.post('/customers/add', action.payload);
        yield put({ type: ADD_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchAddCustomer() {
    yield takeLatest(ADD_CUSTOMER_PROGRESS, addCustomerSaga);
}

function* editDeleteCustomer(action) {
    try {
        const response = yield axiosClient.put(`/customers/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCustomer() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_PROGRESS, editDeleteCustomer);
}

function* importCustomerSaga(action) {
    try {
        const response = yield axiosClient.post('/customers/import', action.payload,);// { headers: { authToken: token } }
        yield put({ type: ADD_IMPORT_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_IMPORT_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchimportCustomer() {
    yield takeLatest(ADD_IMPORT_CUSTOMER_PROGRESS, importCustomerSaga);
}
// ============================= CYLINDER HOLDING LIMIT Master ==============================

function* getCylinderHoldingLimitListSaga(action) {
    try {
        const response = yield axiosClient.get(`/chl/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS, cyl_holding_limit: response.data });
    } catch (error) {
        yield put({ type: GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE });
    }
}

function* watchGetCylinderHoldingLimitList() {
    yield takeLatest(GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS, getCylinderHoldingLimitListSaga);
}

function* addCylinderHoldingLimitSaga(action) {
    try {
        const response = yield axiosClient.post('/chl/add', action.payload);
        yield put({ type: ADD_CYLINDER_HOLDING_LIMIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_HOLDING_LIMIT_FAILURE, payload: error.message });
    }
}

function* watchAddCylinderHoldingLimit() {
    yield takeLatest(ADD_CYLINDER_HOLDING_LIMIT_PROGRESS, addCylinderHoldingLimitSaga);
}

function* editDeleteCylinderHoldingLimit(action) {
    try {
        const response = yield axiosClient.put(`/chl/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCylinderHoldingLimit() {
    yield takeLatest(EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS, editDeleteCylinderHoldingLimit);
}

// ============================= _CYLINDER_ Master ==============================

function* getCylinderListSaga(action) {
    try {
        const response = yield axiosClient.get(`/cylinder/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CYLINDER_LIST_SUCCESS, cylinder: response.data });
    } catch (error) {
        yield put({ type: GET_CYLINDER_LIST_FAILURE });
    }
}

function* watchGetCylinderList() {
    yield takeLatest(GET_CYLINDER_LIST_PROGRESS, getCylinderListSaga);
}

function* addCylinderSaga(action) {
    try {
        const response = yield axiosClient.post('/cylinder/add', action.payload);
        yield put({ type: ADD_CYLINDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_FAILURE, payload: error.message });
    }
}

function* watchAddCylinder() {
    yield takeLatest(ADD_CYLINDER_PROGRESS, addCylinderSaga);
}

function* addCylinderCSVSaga(action) {
    try {
        const response = yield axiosClient.post('/cylinder/import', action.payload);
        yield put({ type: ADD_CYLINDER_CSV_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_CSV_FAILURE, payload: error.message });
    }
}
function* watchAddCylinderCSV() {
    yield takeLatest(ADD_CYLINDER_CSV_PROGRESS, addCylinderCSVSaga);
}



function* editDeleteCylinder(action) {
    try {
        const response = yield axiosClient.put(`/cylinder/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CYLINDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CYLINDER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCylinder() {
    yield takeLatest(EDIT_DELETE_CYLINDER_PROGRESS, editDeleteCylinder);
}

// ============================= _INDUSTRY_ Master ==============================

function* getIndustryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/industry/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_INDUSTRY_LIST_SUCCESS, industry: response.data });
    } catch (error) {
        yield put({ type: GET_INDUSTRY_LIST_FAILURE });
    }
}

function* watchGetIndustryList() {
    yield takeLatest(GET_INDUSTRY_LIST_PROGRESS, getIndustryListSaga);
}

function* addIndustrySaga(action) {
    try {
        const response = yield axiosClient.post('/industry/add', action.payload);
        yield put({ type: ADD_INDUSTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_INDUSTRY_FAILURE, payload: error.message });
    }
}

function* watchAddIndustry() {
    yield takeLatest(ADD_INDUSTRY_PROGRESS, addIndustrySaga);
}

function* editDeleteIndustry(action) {
    try {
        const response = yield axiosClient.put(`/industry/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_INDUSTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_INDUSTRY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteIndustry() {
    yield takeLatest(EDIT_DELETE_INDUSTRY_PROGRESS, editDeleteIndustry);
}





// ============================= cylinder tag map Master ==============================

function* getCylinderTagMappingListSaga(action) {
    try {
        const response = yield axiosClient.get(`/clytagmap/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS, CylinderTagMapping: response.data });
        
    } catch (error) {
        yield put({ type: GET_CYLINDER_TAG_MAPPING_LIST_FAILURE });
    }
}

function* watchGetCylinderTagMappingList() {
    yield takeLatest(GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS, getCylinderTagMappingListSaga);
}

function* addCylinderTagMappingSaga(action) {
    try {
        const response = yield axiosClient.post('/clytagmap/add', action.payload);
        yield put({ type: ADD_CYLINDER_TAG_MAPPING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_TAG_MAPPING_FAILURE, payload: error.message });
    }
}

function* watchAddCylinderTagMapping() {
    yield takeLatest(ADD_CYLINDER_TAG_MAPPING_PROGRESS, addCylinderTagMappingSaga);
}

function* editDeleteCylinderTagMapping(action) {
    try {
        const response = yield axiosClient.put(`/clytagmap/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCylinderTagMapping() {
    yield takeLatest(EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS, editDeleteCylinderTagMapping);
}

// ============================= Customer Type Master ==============================

function* getCustomerTypeListSaga(action) {
    try {
        const response = yield axiosClient.get(`/customer-type/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CUSTOMER_TYPE_LIST_SUCCESS, customerType: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_TYPE_LIST_FAILURE });
    }
}

function* watchGetCustomerTypeList() {
    yield takeLatest(GET_CUSTOMER_TYPE_LIST_PROGRESS, getCustomerTypeListSaga);
}

function* addCustomerTypeSaga(action) {
    try {
        const response = yield axiosClient.post('/customer-type/add', action.payload);
        yield put({ type: ADD_CUSTOMER_TYPE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_TYPE_FAILURE, payload: error.message });
    }
}

function* watchAddCustomerType() {
    yield takeLatest(ADD_CUSTOMER_TYPE_PROGRESS, addCustomerTypeSaga);
}

function* editDeleteCustomerType(action) {
    try {
        const response = yield axiosClient.put(`/customer-type/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_TYPE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_TYPE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCustomerType() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_TYPE_PROGRESS, editDeleteCustomerType);
}


// ============================= Customer Category Master ==============================

function* getCustomerCategoryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/customer-category/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CUSTOMER_CATEGORY_LIST_SUCCESS, customerCategory: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_CATEGORY_LIST_FAILURE });
    }
}

function* watchGetCustomerCategoryList() {
    yield takeLatest(GET_CUSTOMER_CATEGORY_LIST_PROGRESS, getCustomerCategoryListSaga);
}

function* addCustomerCategorySaga(action) {
    try {
        const response = yield axiosClient.post('/customer-category/add', action.payload);
        yield put({ type: ADD_CUSTOMER_CATEGORY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_CATEGORY_FAILURE, payload: error.message });
    }
}

function* watchAddCustomerCategory() {
    yield takeLatest(ADD_CUSTOMER_CATEGORY_PROGRESS, addCustomerCategorySaga);
}

function* editDeleteCustomerCategory(action) {
    try {
        const response = yield axiosClient.put(`/customer-category/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCustomerCategory() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS, editDeleteCustomerCategory);
}

// ============================= Cylinder Status Master ==============================

function* getCylinderStatusListSaga(action) {
    try {
        const response = yield axiosClient.get(`/cylinder-status/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CYLINDER_STATUS_LIST_SUCCESS, cylinder_status: response.data });
    } catch (error) {
        yield put({ type: GET_CYLINDER_STATUS_LIST_FAILURE });
    }
}

function* watchGetCylinderStatusList() {
    yield takeLatest(GET_CYLINDER_STATUS_LIST_PROGRESS, getCylinderStatusListSaga);
}

function* addCylinderStatusSaga(action) {
    try {
        const response = yield axiosClient.post('/cylinder-status/add', action.payload);
        yield put({ type: ADD_CYLINDER_STATUS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_STATUS_FAILURE, payload: error.message });
    }
}

function* watchAddCylinderStatus() {
    yield takeLatest(ADD_CYLINDER_STATUS_PROGRESS, addCylinderStatusSaga);
}

function* editDeleteCylinderStatus(action) {
    try {
        const response = yield axiosClient.put(`/cylinder-status/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CYLINDER_STATUS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CYLINDER_STATUS_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCylinderStatus() {
    yield takeLatest(EDIT_DELETE_CYLINDER_STATUS_PROGRESS, editDeleteCylinderStatus);
}

// ============================= UNIT Master ==============================

function* getUnitListSaga(action) {
    try {
        const response = yield axiosClient.get(`/unit/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_UNIT_LIST_SUCCESS, unit: response.data });
    } catch (error) {
        yield put({ type: GET_UNIT_LIST_FAILURE });
    }
}

function* watchGetUnitList() {
    yield takeLatest(GET_UNIT_LIST_PROGRESS, getUnitListSaga);
}

function* addUnitSaga(action) {
    try {
        const response = yield axiosClient.post('/unit/add', action.payload);
        yield put({ type: ADD_UNIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_UNIT_FAILURE, payload: error.message });
    }
}

function* watchAddUnit() {
    yield takeLatest(ADD_UNIT_PROGRESS, addUnitSaga);
}

function* editDeleteUnit(action) {
    try {
        const response = yield axiosClient.put(`/unit/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_UNIT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_UNIT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUnit() {
    yield takeLatest(EDIT_DELETE_UNIT_PROGRESS, editDeleteUnit);
}




// ============================= Depot Master ==============================

function* getDepotListSaga(action) {
    try {
        const response = yield axiosClient.get(`/depot/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_DEPOT_LIST_SUCCESS, depot: response.data });
    } catch (error) {
        yield put({ type: GET_DEPOT_LIST_FAILURE });
    }
}

function* watchGetDepotList() {
    yield takeLatest(GET_DEPOT_LIST_PROGRESS, getDepotListSaga);
}

function* addDepotSaga(action) {
    try {
        const response = yield axiosClient.post('/depot/add', action.payload);
        yield put({ type: ADD_DEPOT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DEPOT_FAILURE, payload: error.message });
    }
}

function* watchAddDepot() {
    yield takeLatest(ADD_DEPOT_PROGRESS, addDepotSaga);
}

function* editDeleteDepot(action) {
    try {
        const response = yield axiosClient.put(`/depot/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_DEPOT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DEPOT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDepot() {
    yield takeLatest(EDIT_DELETE_DEPOT_PROGRESS, editDeleteDepot);
}

// ============================= _RATE_ Master ==============================

function* getRateListSaga(action) {
    try {
        const response = yield axiosClient.get(`/rate/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_RATE_LIST_SUCCESS, rate: response.data });
    } catch (error) {
        yield put({ type: GET_RATE_LIST_FAILURE });
    }
}

function* watchGetRateList() {
    yield takeLatest(GET_RATE_LIST_PROGRESS, getRateListSaga);
}

function* addRateSaga(action) {
    try {
        const response = yield axiosClient.post('/rate/add', action.payload);
        yield put({ type: ADD_RATE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_RATE_FAILURE, payload: error.message });
    }
}

function* watchAddRate() {
    yield takeLatest(ADD_RATE_PROGRESS, addRateSaga);
}

function* editDeleteRate(action) {
    try {
        const response = yield axiosClient.put(`/rate/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_RATE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_RATE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteRate() {
    yield takeLatest(EDIT_DELETE_RATE_PROGRESS, editDeleteRate);
}

// ============================= _RM_ Master ==============================

function* getRmListSaga(action) {
    try {
        const response = yield axiosClient.get(`/rm/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_RM_LIST_SUCCESS, rm: response.data });
    } catch (error) {
        yield put({ type: GET_RM_LIST_FAILURE });
    }
}

function* watchGetRmList() {
    yield takeLatest(GET_RM_LIST_PROGRESS, getRmListSaga);
}

function* addRmSaga(action) {
    try {
        const response = yield axiosClient.post('/rm/add', action.payload);
        yield put({ type: ADD_RM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_RM_FAILURE, payload: error.message });
    }
}

function* watchAddRm() {
    yield takeLatest(ADD_RM_PROGRESS, addRmSaga);
}

function* editDeleteRm(action) {
    try {
        const response = yield axiosClient.put(`/rm/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_RM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_RM_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteRm() {
    yield takeLatest(EDIT_DELETE_RM_PROGRESS, editDeleteRm);
}

// ============================= _ACCOUNT_MANAGER_ Master ==============================

function* getSalesOfficerListSaga(action) {
    try {
        const response = yield axiosClient.get(`/account-manager/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,{headers: {authToken:token }});
        yield put({ type: GET_ACCOUNT_MANAGER_LIST_SUCCESS, account_manager: response.data });
    } catch (error) {
        yield put({ type: GET_ACCOUNT_MANAGER_LIST_FAILURE });
    }
}

function* watchGetSalesOfficerList() {
    yield takeLatest(GET_ACCOUNT_MANAGER_LIST_PROGRESS, getSalesOfficerListSaga);
}

function* addSalesOfficerSaga(action) {
    try {
        const response = yield axiosClient.post('/account-manager/add', action.payload);
        yield put({ type: ADD_ACCOUNT_MANAGER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_ACCOUNT_MANAGER_FAILURE, payload: error.message });
    }
}

function* watchAddSalesOfficer() {
    yield takeLatest(ADD_ACCOUNT_MANAGER_PROGRESS, addSalesOfficerSaga);
}

function* editDeleteSalesOfficer(action) {
    try {
        const response = yield axiosClient.put(`/account-manager/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_ACCOUNT_MANAGER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSalesOfficer() {
    yield takeLatest(EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, editDeleteSalesOfficer);
}

// ============================= Customer Product Details Master ==============================

function* getCpdListSaga(action) {
    try {
        const response = yield axiosClient.get(`/cpd/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CPD_LIST_SUCCESS, cpd: response.data });
    } catch (error) {
        yield put({ type: GET_CPD_LIST_FAILURE });
    }
}

function* watchGetCpdList() {
    yield takeLatest(GET_CPD_LIST_PROGRESS, getCpdListSaga);
}

function* addCpdSaga(action) {
    try {
        const response = yield axiosClient.post('/cpd/add', action.payload);
        yield put({ type: ADD_CPD_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CPD_FAILURE, payload: error.message });
    }
}

function* watchAddCpd() {
    yield takeLatest(ADD_CPD_PROGRESS, addCpdSaga);
}

function* editDeleteCpd(action) {
    try {
        const response = yield axiosClient.put(`/cpd/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CPD_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CPD_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCpd() {
    yield takeLatest(EDIT_DELETE_CPD_PROGRESS, editDeleteCpd);
}

// ============================= _UOM_CONVERSION_ Master ==============================

function* getUomConversionListSaga(action) {
    try {
        const response = yield axiosClient.get(`/uom-con/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_UOM_CONVERSION_LIST_SUCCESS, uom_conversion: response.data });
    } catch (error) {
        yield put({ type: GET_UOM_CONVERSION_LIST_FAILURE });
    }
}

function* watchGetUomConversionList() {
    yield takeLatest(GET_UOM_CONVERSION_LIST_PROGRESS, getUomConversionListSaga);
}

function* addUomConversionSaga(action) {
    try {
        const response = yield axiosClient.post('/uom-con/add', action.payload);
        yield put({ type: ADD_UOM_CONVERSION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_UOM_CONVERSION_FAILURE, payload: error.message });
    }
}

function* watchAddUomConversion() {
    yield takeLatest(ADD_UOM_CONVERSION_PROGRESS, addUomConversionSaga);
}

function* editDeleteUomConversion(action) {
    try {
        const response = yield axiosClient.put(`/uom-con/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_UOM_CONVERSION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_UOM_CONVERSION_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUomConversion() {
    yield takeLatest(EDIT_DELETE_UOM_CONVERSION_PROGRESS, editDeleteUomConversion);
}


// ============================= UOM Master ==============================

function* getUomListSaga(action) {
    try {
        const response = yield axiosClient.get(`/uom/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_UOM_LIST_SUCCESS, uom: response.data });
    } catch (error) {
        yield put({ type: GET_UOM_LIST_FAILURE });
    }
}

function* watchGetUomList() {
    yield takeLatest(GET_UOM_LIST_PROGRESS, getUomListSaga);
}

function* addUomSaga(action) {
    try {
        const response = yield axiosClient.post('/uom/add', action.payload);
        yield put({ type: ADD_UOM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_UOM_FAILURE, payload: error.message });
    }
}

function* watchAddUom() {
    yield takeLatest(ADD_UOM_PROGRESS, addUomSaga);
}

function* editDeleteUom(action) {
    try {
        const response = yield axiosClient.put(`/uom/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_UOM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_UOM_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUom() {
    yield takeLatest(EDIT_DELETE_UOM_PROGRESS, editDeleteUom);
}

// ============================= Location Master ==============================

function* getLocationListSaga(action) {
    try {
        const response = yield axiosClient.get(`/location/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_LOCATION_LIST_SUCCESS, location: response.data });
    } catch (error) {
        yield put({ type: GET_LOCATION_LIST_FAILURE });
    }
}

function* watchGetLocationList() {
    yield takeLatest(GET_LOCATION_LIST_PROGRESS, getLocationListSaga);
}

function* addLocationSaga(action) {
    try {
        const response = yield axiosClient.post('/location/add', action.payload);
        yield put({ type: ADD_LOCATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_LOCATION_FAILURE, payload: error.message });
    }
}

function* watchAddLocation() {
    yield takeLatest(ADD_LOCATION_PROGRESS, addLocationSaga);
}

function* editDeleteLocation(action) {
    try {
        const response = yield axiosClient.put(`/location/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_LOCATION_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_LOCATION_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteLocation() {
    yield takeLatest(EDIT_DELETE_LOCATION_PROGRESS, editDeleteLocation);
}

// ============================= Supplier Master ==============================

function* getSupplierListSaga(action) {
    try {
        const response = yield axiosClient.get(`supplier/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_SUPPLIER_LIST_SUCCESS, supplier: response.data });
    } catch (error) {
        yield put({ type: GET_SUPPLIER_LIST_FAILURE });
    }
}

function* watchGetSupplierList() {
    yield takeLatest(GET_SUPPLIER_LIST_PROGRESS, getSupplierListSaga);
}

function* addSupplierSaga(action) {
    try {
        const response = yield axiosClient.post('/supplier/add', action.payload);
        yield put({ type: ADD_SUPPLIER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SUPPLIER_FAILURE, payload: error.message });
    }
}

function* watchAddSupplier() {
    yield takeLatest(ADD_SUPPLIER_PROGRESS, addSupplierSaga);
}

function* editDeleteSupplier(action) {
    try {
        const response = yield axiosClient.put(`/supplier/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_SUPPLIER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SUPPLIER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSupplier() {
    yield takeLatest(EDIT_DELETE_SUPPLIER_PROGRESS, editDeleteSupplier);
}

function* importSupplierSaga(action) {
    try {
        const response = yield axiosClient.post('/supplier/import', action.payload,);// { headers: { authToken: token } }
        yield put({ type: ADD_IMPORT_SUPPLIER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_IMPORT_SUPPLIER_FAILURE, payload: error.message });
    }
}

function* watchimportSupplier() {
    yield takeLatest(ADD_IMPORT_SUPPLIER_PROGRESS, importSupplierSaga);
}

// ============================= User Master ==============================

function* getUserListSaga(action) {
    try {
        const response = yield axiosClient.get(`user/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_USER_LIST_SUCCESS, user: response.data });
    } catch (error) {
        yield put({ type: GET_USER_LIST_FAILURE });
    }
}

function* watchGetUserList() {
    yield takeLatest(GET_USER_LIST_PROGRESS, getUserListSaga);
}

function* addUserSaga(action) {
    try {
        const response = yield axiosClient.post('/user/add', action.payload);
        yield put({ type: ADD_USER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_USER_FAILURE, payload: error.message });
    }
}

function* watchAddUser() {
    yield takeLatest(ADD_USER_PROGRESS, addUserSaga);
}

function* editDeleteUser(action) {
    try {
        const response = yield axiosClient.put(`/user/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_USER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_USER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteUser() {
    yield takeLatest(EDIT_DELETE_USER_PROGRESS, editDeleteUser);
}


// ============================= Driver Master ==============================

function* getDriverListSaga(action) {
    try {
        const response = yield axiosClient.get(`driver/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_DRIVER_LIST_SUCCESS, driver: response.data });
    } catch (error) {
        yield put({ type: GET_DRIVER_LIST_FAILURE });
    }
}

function* watchGetDriverList() {
    yield takeLatest(GET_DRIVER_LIST_PROGRESS, getDriverListSaga);
}

function* addDriverSaga(action) {
    try {
        const response = yield axiosClient.post('/driver/add', action.payload);
        yield put({ type: ADD_DRIVER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DRIVER_FAILURE, payload: error.message });
    }
}

function* watchAddDriver() {
    yield takeLatest(ADD_DRIVER_PROGRESS, addDriverSaga);
}

function* editDeleteDriver(action) {
    try {
        const response = yield axiosClient.put(`/driver/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_DRIVER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DRIVER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDriver() {
    yield takeLatest(EDIT_DELETE_DRIVER_PROGRESS, editDeleteDriver);
}


// ============================= Vehicle Master ==============================

function* getVehicleListSaga(action) {
    try {
        const response = yield axiosClient.get(`vehicle/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_VEHICLE_LIST_SUCCESS, vehicle: response.data });
    } catch (error) {
        yield put({ type: GET_VEHICLE_LIST_FAILURE });
    }
}

function* watchGetVehicleList() {
    yield takeLatest(GET_VEHICLE_LIST_PROGRESS, getVehicleListSaga);
}

function* addVehicleSaga(action) {
    try {
        const response = yield axiosClient.post('/vehicle/add', action.payload);
        yield put({ type: ADD_VEHICLE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_VEHICLE_FAILURE, payload: error.message });
    }
}

function* watchAddVehicle() {
    yield takeLatest(ADD_VEHICLE_PROGRESS, addVehicleSaga);
}

function* editDeleteVehicle(action) {
    try {
        const response = yield axiosClient.put(`/vehicle/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_VEHICLE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_VEHICLE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteVehicle() {
    yield takeLatest(EDIT_DELETE_VEHICLE_PROGRESS, editDeleteVehicle);
}


// ============================= Route Master ==============================

function* getRouteListSaga(action) {
    try {
        const response = yield axiosClient.get(`route/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_ROUTE_LIST_SUCCESS, route: response.data });
    } catch (error) {
        yield put({ type: GET_ROUTE_LIST_FAILURE });
    }
}

function* watchGetRouteList() {
    yield takeLatest(GET_ROUTE_LIST_PROGRESS, getRouteListSaga);
}

function* addRouteSaga(action) {
    try {
        const response = yield axiosClient.post('/route/add', action.payload);
        yield put({ type: ADD_ROUTE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_ROUTE_FAILURE, payload: error.message });
    }
}

function* watchAddRoute() {
    yield takeLatest(ADD_ROUTE_PROGRESS, addRouteSaga);
}

function* editDeleteRoute(action) {
    try {
        const response = yield axiosClient.put(`/route/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_ROUTE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_ROUTE_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteRoute() {
    yield takeLatest(EDIT_DELETE_ROUTE_PROGRESS, editDeleteRoute);
}

// ============================= Product Master ==============================

function* getProductListSaga(action) {
    try {
        const response = yield axiosClient.get(`/product/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_PRODUCT_LIST_SUCCESS, product: response.data });
    } catch (error) {
        yield put({ type: GET_PRODUCT_LIST_FAILURE });
    }
}

function* watchGetProductList() {
    yield takeLatest(GET_PRODUCT_LIST_PROGRESS, getProductListSaga);
}

function* addProductSaga(action) {
    try {
        const response = yield axiosClient.post('/product/add', action.payload);
        yield put({ type: ADD_PRODUCT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PRODUCT_FAILURE, payload: error.message });
    }
}

function* watchAddProduct() {
    yield takeLatest(ADD_PRODUCT_PROGRESS, addProductSaga);
}

function* editDeleteProduct(action) {
    try {
        const response = yield axiosClient.put(`/product/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_PRODUCT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PRODUCT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteProduct() {
    yield takeLatest(EDIT_DELETE_PRODUCT_PROGRESS, editDeleteProduct);
}

//  --------------------------------- Transactions ---------------------------------------


// ============================= Delivery Challan customer ==============================

function* getcustomerDeliveryChallanListSaga(action) {
    try {
        const response = yield axiosClient.get(`/delivery-challan-customer/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS, delivery_challan_customer: response.data });
    } catch (error) {
        yield put({ type: GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE });
    }
}

function* watchGetcustomerDeliveryChallanList() {
    yield takeLatest(GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS, getcustomerDeliveryChallanListSaga);
}

function* addcustomerDeliveryChallanSaga(action) {
    try {
        const response = yield axiosClient.post('/delivery-challan-customer/add', action.payload);
        yield put({ type: ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchAddcustomerDeliveryChallan() {
    yield takeLatest(ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS, addcustomerDeliveryChallanSaga);
}

function* editDeletecustomerDeliveryChallan(action) {
    try {
        const response = yield axiosClient.put(`/delivery-challan-customer/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE, payload: error.message });
    }
}

function* watchEditDeletecustomerDeliveryChallan() {
    yield takeLatest(EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS, editDeletecustomerDeliveryChallan);
}

// ============================= Delivery Challan supplier ==============================

function* getDeliveryChallanListSaga(action) {
    try {
        const response = yield axiosClient.get(`/delivery-challan/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_DELIVERY_CHALLAN_LIST_SUCCESS, delivery_challan: response.data });
    } catch (error) {
        yield put({ type: GET_DELIVERY_CHALLAN_LIST_FAILURE });
    }
}

function* watchGetDeliveryChallanList() {
    yield takeLatest(GET_DELIVERY_CHALLAN_LIST_PROGRESS, getDeliveryChallanListSaga);
}

function* addDeliveryChallanSaga(action) {
    try {
        const response = yield axiosClient.post('/delivery-challan/add', action.payload);
        yield put({ type: ADD_DELIVERY_CHALLAN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DELIVERY_CHALLAN_FAILURE, payload: error.message });
    }
}

function* watchAddDeliveryChallan() {
    yield takeLatest(ADD_DELIVERY_CHALLAN_PROGRESS, addDeliveryChallanSaga);
}

function* editDeleteDeliveryChallan(action) {
    try {
        const response = yield axiosClient.put(`/delivery-challan/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DELIVERY_CHALLAN_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDeliveryChallan() {
    yield takeLatest(EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS, editDeleteDeliveryChallan);
}

// ============================= Delivery Order ==============================

function* getDeliveryOrderListSaga(action) {
    try {
        const response = yield axiosClient.get(`/delivery-order/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_DELIVERY_ORDER_LIST_SUCCESS, delivery_order: response.data });
    } catch (error) {
        yield put({ type: GET_DELIVERY_ORDER_LIST_FAILURE });
    }
}

function* watchGetDeliveryOrderList() {
    yield takeLatest(GET_DELIVERY_ORDER_LIST_PROGRESS, getDeliveryOrderListSaga);
}

function* addDeliveryOrderSaga(action) {
    try {
        const response = yield axiosClient.post('/delivery-order/add', action.payload);
        yield put({ type: ADD_DELIVERY_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_DELIVERY_ORDER_FAILURE, payload: error.message });
    }
}

function* watchAddDeliveryOrder() {
    yield takeLatest(ADD_DELIVERY_ORDER_PROGRESS, addDeliveryOrderSaga);
}

function* editDeleteDeliveryOrder(action) {
    try {
        const response = yield axiosClient.put(`/delivery-order/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_DELIVERY_ORDER_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_DELIVERY_ORDER_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteDeliveryOrder() {
    yield takeLatest(EDIT_DELETE_DELIVERY_ORDER_PROGRESS, editDeleteDeliveryOrder);
}



// ============================= GRN ==============================
function* getGrnListSaga(action) {
    try {
        const response = yield axiosClient.get(`/grn/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_GRN_LIST_SUCCESS, grn: response.data });
    } catch (error) {
        yield put({ type: GET_GRN_LIST_FAILURE });
    }
}

function* watchGetGrnList() {
    yield takeLatest(GET_GRN_LIST_PROGRESS, getGrnListSaga);
}

function* addGrnSaga(action) {
    try {
        const response = yield axiosClient.post('/grn/add', action.payload);
        yield put({ type: ADD_GRN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_GRN_FAILURE, payload: error.message });
    }
}

function* watchAddgrn() {
    yield takeLatest(ADD_GRN_PROGRESS, addGrnSaga);
}

function* editDeletegrn(action) {
    try {
        const response = yield axiosClient.put(`/grn/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_GRN_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_GRN_FAILURE, payload: error.message });
    }
}

function* watchEditDeletegrn() {
    yield takeLatest(EDIT_DELETE_GRN_PROGRESS, editDeletegrn);
}



//  --------------------------------- Production Entries ----------------------------------------------------------------

// ============================= Schedule Entry   ======================================================================

function* getScheduleEntryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/schedule-entry/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_SCHEDULE_ENTRY_LIST_SUCCESS, schedule_entry: response.data });
    } catch (error) {
        yield put({ type: GET_SCHEDULE_ENTRY_LIST_FAILURE });
    }
}

function* watchGetScheduleEntryList() {
    yield takeLatest(GET_SCHEDULE_ENTRY_LIST_PROGRESS, getScheduleEntryListSaga);
}

function* addScheduleEntrySaga(action) {
    try {
        const response = yield axiosClient.post('/schedule-entry/add', action.payload);
        yield put({ type: ADD_SCHEDULE_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_SCHEDULE_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchAddScheduleEntry() {
    yield takeLatest(ADD_SCHEDULE_ENTRY_PROGRESS, addScheduleEntrySaga);
}

function* editDeleteScheduleEntry(action) {
    try {
        const response = yield axiosClient.put(`/schedule-entry/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_SCHEDULE_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteScheduleEntry() {
    yield takeLatest(EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS, editDeleteScheduleEntry);
}


// ============================= Production Planning   ======================================================================

function* getProductionPlanningListSaga(action) {
    try {
        const response = yield axiosClient.get(`/production-planning/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_PRODUCTION_PLANNING_LIST_SUCCESS, production_planning: response.data });
    } catch (error) {
        yield put({ type: GET_PRODUCTION_PLANNING_LIST_FAILURE });
    }
}

function* watchGetProductionPlanningList() {
    yield takeLatest(GET_PRODUCTION_PLANNING_LIST_PROGRESS, getProductionPlanningListSaga);
}

function* addProductionPlanningSaga(action) {
    try {
        const response = yield axiosClient.post('/production-planning/add', action.payload);
        yield put({ type: ADD_PRODUCTION_PLANNING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PRODUCTION_PLANNING_FAILURE, payload: error.message });
    }
}

function* watchAddProductionPlanning() {
    yield takeLatest(ADD_PRODUCTION_PLANNING_PROGRESS, addProductionPlanningSaga);
}

function* editDeleteProductionPlanning(action) {
    try {
        const response = yield axiosClient.put(`/production-planning/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PRODUCTION_PLANNING_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteProductionPlanning() {
    yield takeLatest(EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS, editDeleteProductionPlanning);
}

// ============================= Production Entry   ======================================================================

function* getProductionEntryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/production-entry/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_PRODUCTION_ENTRY_LIST_SUCCESS, production_entry: response.data });
    } catch (error) {
        yield put({ type: GET_PRODUCTION_ENTRY_LIST_FAILURE });
    }
}

function* watchGetProductionEntryList() {
    yield takeLatest(GET_PRODUCTION_ENTRY_LIST_PROGRESS, getProductionEntryListSaga);
}

function* addProductionEntrySaga(action) {
    try {
        const response = yield axiosClient.post('/production-entry/add', action.payload);
        yield put({ type: ADD_PRODUCTION_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PRODUCTION_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchAddProductionEntry() {
    yield takeLatest(ADD_PRODUCTION_ENTRY_PROGRESS, addProductionEntrySaga);
}

function* editDeleteProductionEntry(action) {
    try {
        const response = yield axiosClient.put(`/production-entry/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PRODUCTION_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteProductionEntry() {
    yield takeLatest(EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS, editDeleteProductionEntry);
}

// ============================= Quality Entry   ======================================================================

function* getQualityEntryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/quality-entry/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_QUALITY_ENTRY_LIST_SUCCESS, quality_entry: response.data });
    } catch (error) {
        yield put({ type: GET_QUALITY_ENTRY_LIST_FAILURE });
    }
}

function* watchGetQualityEntryList() {
    yield takeLatest(GET_QUALITY_ENTRY_LIST_PROGRESS, getQualityEntryListSaga);
}

function* addQualityEntrySaga(action) {
    try {
        const response = yield axiosClient.post('/quality-entry/add', action.payload);
        yield put({ type: ADD_QUALITY_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_QUALITY_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchAddQualityEntry() {
    yield takeLatest(ADD_QUALITY_ENTRY_PROGRESS, addQualityEntrySaga);
}

function* editDeleteQualityEntry(action) {
    try {
        const response = yield axiosClient.put(`/quality-entry/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_QUALITY_ENTRY_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_QUALITY_ENTRY_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteQualityEntry() {
    yield takeLatest(EDIT_DELETE_QUALITY_ENTRY_PROGRESS, editDeleteQualityEntry);
}


//  --------------------------------- Store Entries ----------------------------------------------------------------

// ============================= Empty Cylinder Inspection Master ==============================

function* getEciListSaga(action) {
    try {
        const response = yield axiosClient.get(`/eci/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_ECI_LIST_SUCCESS, eci: response.data });
    } catch (error) {
        yield put({ type: GET_ECI_LIST_FAILURE });
    }
}

function* watchGetEciList() {
    yield takeLatest(GET_ECI_LIST_PROGRESS, getEciListSaga);
}

function* addEciSaga(action) {
    try {
        const response = yield axiosClient.post('/eci/add', action.payload);
        yield put({ type: ADD_ECI_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_ECI_FAILURE, payload: error.message });
    }
}

function* watchAddEci() {
    yield takeLatest(ADD_ECI_PROGRESS, addEciSaga);
}

function* editDeleteEci(action) {
    try {
        const response = yield axiosClient.put(`/eci/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_ECI_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_ECI_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteEci() {
    yield takeLatest(EDIT_DELETE_ECI_PROGRESS, editDeleteEci);
}



// ============================= Cylinder Inward   ======================================================================

function* getCylinderInwardListSaga(action) {
    try {
        const response = yield axiosClient.get(`/cyl-inward/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CYLINDER_INWARD_LIST_SUCCESS, cylinder_inward: response.data });
    } catch (error) {
        yield put({ type: GET_CYLINDER_INWARD_LIST_FAILURE });
    }
}

function* watchGetCylinderInwardList() {
    yield takeLatest(GET_CYLINDER_INWARD_LIST_PROGRESS, getCylinderInwardListSaga);
}

function* addCylinderInwardSaga(action) {
    try {
        const response = yield axiosClient.post('/cyl-inward/add', action.payload);
        yield put({ type: ADD_CYLINDER_INWARD_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CYLINDER_INWARD_FAILURE, payload: error.message });
    }
}

function* watchAddCylinderInward() {
    yield takeLatest(ADD_CYLINDER_INWARD_PROGRESS, addCylinderInwardSaga);
}

function* editDeleteCylinderInward(action) {
    try {
        const response = yield axiosClient.put(`/cyl-inward/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CYLINDER_INWARD_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CYLINDER_INWARD_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteCylinderInward() {
    yield takeLatest(EDIT_DELETE_CYLINDER_INWARD_PROGRESS, editDeleteCylinderInward);
}

// ============================= Internal Movementt Entry   ======================================================================

function* getInternalMovementListSaga(action) {
    try {
        const response = yield axiosClient.get(`/ime/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_INTERNAL_MOVEMENT_LIST_SUCCESS, internal_movement: response.data });
    } catch (error) {
        yield put({ type: GET_INTERNAL_MOVEMENT_LIST_FAILURE });
    }
}

function* watchGetInternalMovementList() {
    yield takeLatest(GET_INTERNAL_MOVEMENT_LIST_PROGRESS, getInternalMovementListSaga);
}

function* addInternalMovementSaga(action) {
    try {
        const response = yield axiosClient.post('/ime/add', action.payload);
        yield put({ type: ADD_INTERNAL_MOVEMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_INTERNAL_MOVEMENT_FAILURE, payload: error.message });
    }
}

function* watchAddInternalMovement() {
    yield takeLatest(ADD_INTERNAL_MOVEMENT_PROGRESS, addInternalMovementSaga);
}

function* editDeleteInternalMovement(action) {
    try {
        const response = yield axiosClient.put(`/ime/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteInternalMovement() {
    yield takeLatest(EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS, editDeleteInternalMovement);
}




//  --------------------------------- Sales Entries ----------------------------------------------------------------

// ============================= Entries   ======================================================================

// ============================= Customer PO   ======================================================================

function* getSalesOrderListSaga(action) {
    try {
        const response = yield axiosClient.get(`/customer-po/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_CUSTOMER_PO_LIST_SUCCESS, customer_po: response.data });
    } catch (error) {
        yield put({ type: GET_CUSTOMER_PO_LIST_FAILURE });
    }
}

function* watchGetSalesOrderList() {
    yield takeLatest(GET_CUSTOMER_PO_LIST_PROGRESS, getSalesOrderListSaga);
}

function* addSalesOrderSaga(action) {
    try {
        const response = yield axiosClient.post('/customer-po/add', action.payload);
        yield put({ type: ADD_CUSTOMER_PO_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_CUSTOMER_PO_FAILURE, payload: error.message });
    }
}

function* watchAddSalesOrder() {
    yield takeLatest(ADD_CUSTOMER_PO_PROGRESS, addSalesOrderSaga);
}

function* editDeleteSalesOrder(action) {
    try {
        const response = yield axiosClient.put(`/customer-po/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_CUSTOMER_PO_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_CUSTOMER_PO_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteSalesOrder() {
    yield takeLatest(EDIT_DELETE_CUSTOMER_PO_PROGRESS, editDeleteSalesOrder);
}



//  --------------------------------- Utility ---------------------------------------

// ============================= BOM ==============================

function* getBomListSaga(action) {
    try {
        const response = yield axiosClient.get(`/bom/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type: GET_BOM_LIST_SUCCESS, bom: response.data });
    } catch (error) {
        yield put({ type: GET_BOM_LIST_FAILURE });
    }
}

function* watchGetBomList() {
    yield takeLatest(GET_BOM_LIST_PROGRESS, getBomListSaga);
}

function* addBomSaga(action) {
    try {
        const response = yield axiosClient.post('/bom/add', action.payload);
        yield put({ type: ADD_BOM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_BOM_FAILURE, payload: error.message });
    }
}

function* watchAddBom() {
    yield takeLatest(ADD_BOM_PROGRESS, addBomSaga);
}

function* editDeleteBom(action) {
    try {
        const response = yield axiosClient.put(`/bom/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_BOM_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_BOM_FAILURE, payload: error.message });
    }
}

function* watchEditDeleteBom() {
    yield takeLatest(EDIT_DELETE_BOM_PROGRESS, editDeleteBom);
}


// --------------------------PICKUP ENTRY-----------
function* getpickupentryListSaga(action) {
    try {
        const response = yield axiosClient.get(`/pickup_entry/list?page=${action.payload.page}&&size=${action.payload.size}&&searchKey=${action.payload.searchKey}`,);
        yield put({ type:  GET_PICKUP_LIST_SUCCESS, delivery_challan_customer: response.data });
    } catch (error) {
        yield put({ type:  GET_PICKUP_LIST_FAILURE });
    }
}

function* watchGetpickupentryList() {
    yield takeLatest(GET_PICKUP_LIST_PROGRESS, getpickupentryListSaga);
}

function* addpickupentrySaga(action) {
    try {
        const response = yield axiosClient.post('/pickup_entry/add', action.payload);
        yield put({ type: ADD_PICKUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADD_PICKUP_FAILURE, payload: error.message });
    }
}

function* watchAddpickupentry() {
    yield takeLatest(ADD_PICKUP_PROGRESS, addpickupentrySaga);
}

function* editDeletepickupentry(action) {
    try {
        const response = yield axiosClient.put(`/pickup_entry/editDelete`, action.payload);
        yield put({ type: EDIT_DELETE_PICKUP_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: EDIT_DELETE_PICKUP_FAILURE, payload: error.message });
    }
}

function* watchEditDeletepickupentry() {
    yield takeLatest(EDIT_DELETE_PICKUP_PROGRESS, editDeletepickupentry);
}







// ----------------------------------------------------------

export default function* rootSaga() {
    yield all([
        watchLogin(), watchLogout(),
        watchGetCustomerList(), watchAddCustomer(), watchEditDeleteCustomer(),
        watchGetCylinderHoldingLimitList(), watchAddCylinderHoldingLimit(), watchEditDeleteCylinderHoldingLimit(),
        watchGetCylinderList(), watchAddCylinder(), watchEditDeleteCylinder(),
        watchGetIndustryList(), watchAddIndustry(), watchEditDeleteIndustry(),
        watchGetUnitList(), watchAddUnit(), watchEditDeleteUnit(),
        watchGetRateList(), watchAddRate(), watchEditDeleteRate(),
        watchGetRmList(), watchAddRm(), watchEditDeleteRm(),
        watchGetSalesOfficerList(), watchAddSalesOfficer(), watchEditDeleteSalesOfficer(),
        watchGetUomConversionList(), watchAddUomConversion(), watchEditDeleteUomConversion(),
        watchGetUomList(), watchAddUom(), watchEditDeleteUom(),
        watchGetSalesOrderList(), watchAddSalesOrder(), watchEditDeleteSalesOrder(),
        watchGetDeliveryChallanList(), watchAddDeliveryChallan(), watchEditDeleteDeliveryChallan(),
        watchGetSupplierList(), watchAddSupplier(), watchEditDeleteSupplier(), watchGetDriverList(), watchAddDriver(), watchEditDeleteDriver(),
        watchAddProduct(), watchGetProductList(), watchEditDeleteProduct(),
        watchAddScheduleEntry(), watchGetScheduleEntryList(), watchEditDeleteScheduleEntry(),
        watchEditDeletegrn(), watchAddgrn(), watchGetGrnList(),
        watchEditDeleteProductionPlanning(), watchGetProductionPlanningList(), watchAddProductionPlanning(),
        watchEditDeleteCylinderInward(), watchAddCylinderInward(), watchGetCylinderInwardList(),
        watchEditDeleteBom(), watchAddBom(), watchGetBomList(),
        watchimportCustomer(), watchimportSupplier(), watchGetCustomerTypeList(), watchAddCustomerType(), watchEditDeleteCustomerType(),
        watchGetCylinderStatusList(), watchAddCylinderStatus(), watchEditDeleteCylinderStatus(),
        watchGetProductionEntryList(), watchAddProductionEntry(), watchEditDeleteProductionEntry(),
        watchEditDeleteQualityEntry(), watchAddQualityEntry(), watchGetQualityEntryList(),
        watchGetDeliveryOrderList(), watchAddDeliveryOrder(), watchEditDeleteDeliveryOrder(),
        watchGetLocationList(), watchAddLocation(), watchEditDeleteLocation(),
        watchGetCpdList(), watchAddCpd(), watchEditDeleteCpd(),
        watchGetCustomerCategoryList(), watchAddCustomerCategory(), watchEditDeleteCustomerCategory(),
        watchGetEciList(), watchAddEci(), watchEditDeleteEci(),
        watchGetInternalMovementList(), watchAddInternalMovement(), watchEditDeleteInternalMovement(),
        watchEditDeleteVehicle(), watchAddVehicle(), watchGetVehicleList(),
        watchGetRouteList(), watchAddRoute(), watchEditDeleteRoute(),
        watchGetUserList(), watchAddUser(), watchEditDeleteUser(),
        watchEditDeleteDepot() ,watchAddDepot(),watchGetDepotList(),watchAddCylinderCSV(),
        watchGetCylinderTagMappingList(),watchAddCylinderTagMapping(),watchEditDeleteCylinderTagMapping(),
        watchEditDeletecustomerDeliveryChallan(),watchAddcustomerDeliveryChallan(),watchGetcustomerDeliveryChallanList(),
        watchGetpickupentryList(),watchAddpickupentry(),watchEditDeletepickupentry()


    ])

}